import { createSlice } from "@reduxjs/toolkit"

const admindataSlice = createSlice({
    name: 'admindata',
    initialState: {allusers: [], selectedusers: []},
    reducers: {
        setAllUserData: (state, action) => {
            state.allusers = action.payload
        },
        setSelectedUsers: (state, action) => {
            state.selectedusers = action.payload
        },
    },
})

export const { setAllUserData, setSelectedUsers } = admindataSlice.actions

export default admindataSlice.reducer

export const selectAllUserData = (state) => state.admindata.allusers
export const selectSelectedUsers = (state) => state.admindata.selectedusers

